import { useState } from "react";

export default function RoomsOrPropose({isSmall, defaultValue, land, errors }) {
  const [selected, setSelected] = useState([]);

  const handleClick = (value) => {
    if (selected.includes(value)) {
      setSelected(selected.filter((v) => v !== value)); // снимаем выбор при повторном клике
    } else {
      setSelected([...selected, value]); // выбираем новое значение
    }
  };
  const options = [
    { id: "ll1", label: "ԲՆԱԿԵԼԻ", value: "Residential" },
    { id: "ll2", label: "ԳՅՈՒՂԱՏՆՏԵՍԱԿԱՆ", value: "Agricultural" },
    { id: "ll3", label: "ԿՈՄԵՐՑԻՈՆ", value: "Commercial" },
    { id: "ll4", label: "ԱՅԼ", value: "Other" },
  ];
  
  return (
    <div className="roomsOrPorpose">
      
      {!land && (
        <div className={errors?.rooms ? "error" : ""}>
          <h5>{isSmall ? "ՍԵՆՅ." : "ՍԵՆՅԱԿՆԵՐ"}</h5>

          <div className="with">
            {[
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
            ].map((v) => (
              <div key={v}>
                <input
                  type="checkbox"
                  name="rooms"
                  id={`r${v}`}
                  value={v}
                  checked={
                    selected.includes(Number(v)) ||
                    (!selected.length && Number(v) === defaultValue)
                  }
                  onChange={() => handleClick(Number(v))}
                />
                <label htmlFor={`r${v}`}>{v}</label>
              </div>
            ))}
          </div>
        </div>
      )}

      {land && (
        <div className={errors?.propose ? "error" : ""}>
          <h5>{isSmall ? "ՆՊԱՏ." : "ՆՊԱՏԱԿ"}</h5>

          {options.map((v) => (
            <div key={v.value}>
              <input
                type="checkbox"
                name="propose"
                id={v.value}
                value={v.value}
                checked={
                  selected.includes(v.value) ||
                  (!selected.length && v.value === defaultValue)
                } // управляемое состояние
                onChange={() => handleClick(v.value)}
              />
              <label htmlFor={v.value}>{v.label}</label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
